import { z } from 'zod'

export const privateHealthSchema = z.object({
  employment_status: z.enum([
    'permanently_employed',
    'civil_servant',
    'student',
    'apprentice',
    'self_employed',
    'retired',
    'other',
  ]),

  income: z.enum(['less_than_30k', '30k_to_50k', '50k_to_74k', 'more_than_74k']),

  insurance_type: z.enum(['private', 'public', 'none']),
})
